import { createGlobalStyle } from "styled-components"

export const screenSizes = {
  extraSmall: 650,
  small: 900,
  medium: 1200,
  big: 1550,
}

const GlobalStyles = createGlobalStyle`
  /* ...existing code... */

  :root {
    --primaryblue: #25bfea;
    --linkblue: #1b9df1;
    --buttonblue: #1890ff;
    --tableblue: rgb(183, 228, 247,0.5);
    --deepdarkblue: rgb(16,18,66);
    --white: #ffffff;
    --snow: #fafafa;
    --lightgrey: #ecedf0;
    --mediumgrey: #cccccc;
    --darkgrey: #8c8c8c;
    --black: #2E2E2E;
    --cream: #FFFDD0;
    --approvalgreen: #52c41a;
    --rejectionred: #b94a48;
    --rejectionbackground: #ffc2c2;

    /* sider width fallback — DashboardLayout / Sider should set this inline when rendered on desktop */
    --sider-width: 0px;
    /* viewport height token for full-screen app layouts */
    --app-viewport-height: 100vh;
  }

  /* On modern browsers (including iOS Safari 15.4+), prefer the small viewport height
     so full-height sections fit the *visible* screen when browser UI is showing. */
  @supports (height: 100svh) {
    :root {
      --app-viewport-height: 100svh;
    }
  }

  /*
    Museo Sans Rounded - local font files placed in client/public/fonts/
    Using the provided .otf files. For best web performance consider adding woff2/woff versions.
  */
  @font-face {
    font-family: "MuseoSansRounded";
    src:
      url("/fonts/MuseoSansRounded-100.woff2") format("woff2"),
      url("/fonts/MuseoSansRounded-100.woff") format("woff");
    font-weight: 100;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: "MuseoSansRounded";
    src:
      url("/fonts/MuseoSansRounded-100Italic.woff2") format("woff2"),
      url("/fonts/MuseoSansRounded-100Italic.woff") format("woff");
    font-weight: 100;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: "MuseoSansRounded";
    src:
      url("/fonts/MuseoSansRounded-300.woff2") format("woff2"),
      url("/fonts/MuseoSansRounded-300.woff") format("woff");
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: "MuseoSansRounded";
    src:
      url("/fonts/MuseoSansRounded-300Italic.woff2") format("woff2"),
      url("/fonts/MuseoSansRounded-300Italic.woff") format("woff");
    font-weight: 300;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: "MuseoSansRounded";
    src:
      url("/fonts/MuseoSansRounded-500.woff2") format("woff2"),
      url("/fonts/MuseoSansRounded-500.woff") format("woff");
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: "MuseoSansRounded";
    src:
      url("/fonts/MuseoSansRounded-500Italic.woff2") format("woff2"),
      url("/fonts/MuseoSansRounded-500Italic.woff") format("woff");
    font-weight: 500;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: "MuseoSansRounded";
    src:
      url("/fonts/MuseoSansRounded-700.woff2") format("woff2"),
      url("/fonts/MuseoSansRounded-700.woff") format("woff");
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: "MuseoSansRounded";
    src:
      url("/fonts/MuseoSansRounded-700Italic.woff2") format("woff2"),
      url("/fonts/MuseoSansRounded-700Italic.woff") format("woff");
    font-weight: 700;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: "MuseoSansRounded";
    src:
      url("/fonts/MuseoSansRounded-900.woff2") format("woff2"),
      url("/fonts/MuseoSansRounded-900.woff") format("woff");
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: "MuseoSansRounded";
    src:
      url("/fonts/MuseoSansRounded-900Italic.woff2") format("woff2"),
      url("/fonts/MuseoSansRounded-900Italic.woff") format("woff");
    font-weight: 900;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: "MuseoSansRounded";
    src:
      url("/fonts/MuseoSansRounded-1000.woff2") format("woff2"),
      url("/fonts/MuseoSansRounded-1000.woff") format("woff");
    font-weight: 1000;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: "MuseoSansRounded";
    src:
      url("/fonts/MuseoSansRounded-1000Italic.woff2") format("woff2"),
      url("/fonts/MuseoSansRounded-1000Italic.woff") format("woff");
    font-weight: 1000;
    font-style: italic;
    font-display: swap;
  }

  /* Global baseline: apply Museo to body and UI copy as requested */
  html, body, #root {
    font-family: "MuseoSansRounded", "Open Sans", Arial, sans-serif;
    font-weight: 500; /* default body weight requested */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
  }

  /* Root/page overscroll background (rubber-band color) */
  html, body {
    background-color: #ffffff !important;
  }

  /* Prevent global horizontal scroll. This must live ONLY on <body> (with <html> left
     with no overflow override) so body's overflow-x correctly propagates to become the
     real viewport scroller per the CSS spec. Setting overflow-x on html/#root/.ant-layout
     too — even paired with an explicit overflow-y — silently forces overflow-y to "auto"
     on each of them (CSS auto-conversion rule for mismatched x/y overflow), turning every
     one of them into its own disconnected scroll container and breaking position:sticky
     for everything nested inside. Verified via isolated repro — do not reintroduce. */
  body {
    overflow-x: hidden;
  }

  /* Main app layout background behind the white content card */
  #root, .ant-layout {
    background-color: #ffffff !important;
  }

  /* App shell: background behind the white rounded content card */
  .app-shell-layout {
    background-color: #ffffff !important;
  }

  /* App root layout: background for any gaps around header/content */
  .app-root-layout {
    background-color: #ffffff !important;
  }

  /* Override Ant Design header background so it doesn't show dark navy during overscroll */
  .ant-layout-header {
    background-color: transparent !important;
    background: transparent !important;
  }

  /*
    Page header + headings
  */
  .page-header,
  .page-header-bar {
    background: transparent;
    border: none;
    box-shadow: none;
    height: auto;
    margin: 0 0 16px 0;
    padding: 0;
    z-index: auto;
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    width: auto;
    box-sizing: border-box;
  }

  .page-header h2,
  .page-header-bar .page-header-bar-title {
    color: #101242;
    box-sizing: border-box;
    display: block;
    height: auto;
    font-size: 1.75rem;
    letter-spacing: normal;
    line-height: 1.2;
    margin: 0;
    padding: 0;
    position: relative;
    z-index: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }

  /* Keep Font Awesome icons inline with text in legacy .page-header headings */
  .page-header h2 .svg-inline--fa {
    display: inline-block;
    vertical-align: middle;
  }

  .page-header-bar-main {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .page-header-bar-icon {
    font-size: 1.3rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
  }

  .page-header-bar-icon svg {
    display: block;
    vertical-align: middle;
  }

  .page-header-bar-text {
    display: flex;
    flex-direction: column;
  }

  /* TipTap editor: remove browser focus ring/outline, keep only text caret */
  .tiptap-editor-content:focus,
  .tiptap-editor-content:focus-visible,
  .ProseMirror-focused.tiptap-editor-content {
    outline: none !important;
    box-shadow: none !important;
  }

  .page-header-bar-subtitle {
    margin-top: 2px;
    font-size: 0.85rem;
    color: var(--darkgrey, #8c8c8c);
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .page-header-bar-extra {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
  }

  @media only screen and (max-width: ${screenSizes.small}px) {
    .page-header-bar-extra {
      justify-content: flex-start;
      margin-top: 8px;
    }
  }

  /* Headings weights per request */
  h1, h2, h3, h4, h5, h6 {
    font-family: "MuseoSansRounded", "Open Sans", Arial, sans-serif;
    margin: 0;
  }
  h1 { font-weight: 900; }
  h2 { font-weight: 900; }
  h3 { font-weight: 700; }
  h4 { font-weight: 500; }

  /* Strong / bold */
  strong, b { font-weight: 900; }

  /* Ensure Google Places autocomplete dropdown appears above Ant Design modals */
  .pac-container {
    z-index: 2000 !important;
  }

  /* App header icon buttons (avatar, message, menu): hover highlight only */
  .app-header-icon-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: 0;
    border-radius: 8px;
    background-color: transparent;
    cursor: pointer;
    box-sizing: border-box;
    transition: background-color 160ms ease-out;
  }

  .app-header-icon-button:hover {
    background-color: #7ee4ff;
  }

  /* Profile drawer: rounded left edge when opening from the right */
  .profile-drawer-rounded.ant-drawer-content-wrapper,
  .profile-drawer-rounded.ant-drawer-content,
  .profile-drawer-rounded .ant-drawer-content-wrapper,
  .profile-drawer-rounded .ant-drawer-content {
    border-radius: 20px 0 0 20px !important;
    overflow: hidden;
    background-color: #ffffff;
  }

  /* Allow scrolling inside profile drawer body while keeping rounded clipping */
  .profile-drawer-rounded.ant-drawer-body,
  .profile-drawer-rounded .ant-drawer-body {
    border-radius: 20px 0 0 20px !important;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background-color: #ffffff;
  }

  /* Keep Profile / Support / Updates tabs sticky at top of profile drawer */
  .profile-drawer-root .ant-drawer-body .ant-tabs-nav {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #ffffff;
  }

  /* Mobile sidebar drawer: rounded right edge when opening from the left */
  .mobile-sidebar-drawer.ant-drawer-content-wrapper,
  .mobile-sidebar-drawer.ant-drawer-content,
  .mobile-sidebar-drawer.ant-drawer-body,
  .mobile-sidebar-drawer .ant-drawer-content-wrapper,
  .mobile-sidebar-drawer .ant-drawer-content,
  .mobile-sidebar-drawer .ant-drawer-body {
    border-radius: 0 20px 20px 0 !important;
    overflow: hidden;
  }

  /* Sidebar-specific baseline (keeps earlier scoped rules) */
  .sidebar-scroll {
    scrollbar-width: thin;
    scrollbar-color: rgba(0,0,0,0.2) transparent;
    font-family: "MuseoSansRounded", "Open Sans", Arial, sans-serif;
  }

  /* Subtle pulsing dot on the Live Meets nav item when a meet is currently live */
  .sidebar-live-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-left: 8px;
    border-radius: 50%;
    background: #ff3b30;
    box-shadow: 0 0 0 0 rgba(255, 59, 48, 0.55);
    animation: sidebar-live-dot-pulse 1.6s infinite;
    flex-shrink: 0;
  }

  @keyframes sidebar-live-dot-pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 59, 48, 0.55);
    }
    70% {
      box-shadow: 0 0 0 8px rgba(255, 59, 48, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255, 59, 48, 0);
    }
  }
  .sidebar-scroll::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  .sidebar-scroll::-webkit-scrollbar-track {
    background: transparent;
  }
  .sidebar-scroll::-webkit-scrollbar-thumb {
    background: rgba(246, 246, 246, 0);
    border-radius: 6px;
    transition: background-color 150ms ease;
  }
  .sidebar-scroll:hover::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
  }

  /* Sidebar submenu background: slightly lighter navy than primary sider */
  .sidebar-scroll .ant-menu-submenu .ant-menu,
  .sidebar-scroll .ant-menu-submenu-popup .ant-menu {
    background-color: #101242 !important;
  }

  /* Subnav (nested) item hover: blue overlay highlight */
  .sidebar-scroll .ant-menu-submenu .ant-menu-item:hover,
  .sidebar-scroll .ant-menu-submenu-popup .ant-menu-item:hover,
  .sidebar-scroll .ant-menu-submenu .ant-menu-item-active,
  .sidebar-scroll .ant-menu-submenu-popup .ant-menu-item-active {
    background-color: rgba(37, 191, 234, 0.22) !important; /* var(--primaryblue) with transparency */
  }

  /* Sidebar root-level items: full white text + subtle hover motion (root menu only) */
  .sidebar-scroll .ant-menu-root > .ant-menu-item,
  .sidebar-scroll .ant-menu-root > .ant-menu-submenu > .ant-menu-submenu-title {
    color: #ffffff !important;
    transition: color 200ms ease-out, transform 200ms ease-out;
  }

  .sidebar-scroll .ant-menu-root > .ant-menu-item:hover,
  .sidebar-scroll .ant-menu-root > .ant-menu-submenu > .ant-menu-submenu-title:hover {
    transform: translateX(4px);
  }

  /* Ensure consistent font weight for root-level navs (My/Club/League Account, Learn & Support, Curriculum, Websites, Control Panel) */
  .sidebar-scroll .ant-menu-root > .ant-menu-item > .ant-menu-title-content,
  .sidebar-scroll .ant-menu-root > .ant-menu-submenu > .ant-menu-submenu-title > .ant-menu-title-content {
    font-weight: 700 !important;
  }

  /* Also bump the actual clickable text for root-level items that use NavLink + .menu-label */
  .sidebar-scroll .ant-menu-root > .ant-menu-item > .ant-menu-title-content a,
  .sidebar-scroll .ant-menu-root > .ant-menu-item > .ant-menu-title-content .menu-label {
    font-weight: 700 !important;
  }

  /* Do not animate the non-clickable user info row */
  .sidebar-scroll .ant-menu-item.sidebar-user-info-item,
  .sidebar-scroll .ant-menu-item.sidebar-user-info-item:hover {
    transform: none !important;
    transition: none !important;
  }

  /* Two-line submenu header labels (title + responsive subtitle) */
  .sidebar-submenu-label {
    display: flex;
    flex-direction: column;
    line-height: 1.15;
    width: 100%;
  }

  /* Primary line: inherit font-size from AntD menu so it matches other items */
  .sidebar-submenu-title {
    font-weight: 700;
    color: rgba(255, 255, 255, 0.96);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* Subtitle: slightly smaller and responsive */
  .sidebar-submenu-subtitle {
    margin-top: 2px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.78);
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.75rem;
  }

  @media only screen and (max-width: ${screenSizes.small}px) {
    .sidebar-submenu-subtitle {
      font-size: 0.7rem;
    }
  }

  /* Make My Account username subtitle fully white to match club/league names */
  .sidebar-submenu-subtitle-user {
    color: #ffffff !important;
    font-weight: 500 !important;
  }

  /* Subtle non-clickable identity row at top of each submenu (user/club/league) */
  .sidebar-scroll .submenu-identity-header {
    cursor: default !important;
  }

  .sidebar-scroll .submenu-identity-header .ant-menu-title-content {
    font-size: calc(0.7rem + 2px);
    line-height: 1.2;
  }

  .sidebar-scroll .submenu-identity-text {
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: calc(0.7rem + 2px);
    color: rgba(255, 255, 255, 0.72);
    font-style: italic;
  }

  @media only screen and (max-width: ${screenSizes.small}px) {
    .sidebar-scroll .submenu-identity-text {
      font-size: calc(0.65rem + 2px);
    }
  }

  /* Stronger weight for the user identity label only */
  .sidebar-scroll .submenu-identity-text-user {
    font-weight: 700 !important;
  }

  /* Halve vertical height and remove hover/background for identity rows */
  .sidebar-scroll .ant-menu-submenu .ant-menu-item.submenu-identity-header,
  .sidebar-scroll .ant-menu-submenu-popup .ant-menu-item.submenu-identity-header {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    height: 20px !important;
    line-height: 20px !important;
    background-color: transparent !important;
  }

  .sidebar-scroll .ant-menu-submenu .ant-menu-item.submenu-identity-header:hover,
  .sidebar-scroll .ant-menu-submenu-popup .ant-menu-item.submenu-identity-header:hover {
    background-color: transparent !important;
  }

  /* Apply Museo globally to text UI elements (buttons, inputs, labels, links, tables, tooltips, modals, etc.) */
  body, p, span, a, label, button, input, textarea, select, .ant-typography, .ant-typography * {
    font-family: "MuseoSansRounded", "Open Sans", Arial, sans-serif;
    font-weight: 500;
  }

  /* Buttons: primary 700, secondary 500 */
  .ant-btn {
    font-weight: 500;
  }
  .ant-btn-primary {
    font-weight: 700;
  }

  /* Form controls and placeholders: lighter weight */
  input, textarea, select, .ant-input {
    font-weight: 300;
  }
  ::placeholder,
  ::-webkit-input-placeholder {
    font-weight: 700;
    opacity: 0.8 !important;
    color: var(--darkgrey) !important;
  }
  :-ms-input-placeholder {
    font-weight: 700;
    opacity: 0.8 !important;
    color: var(--darkgrey) !important;
  }

  /* Tables, lists, and small UI text */
  table, th, td, li {
    font-family: "MuseoSansRounded", "Open Sans", Arial, sans-serif;
    font-weight: 500;
  }

  /* Tooltips, popovers, modal content */
  .ant-tooltip-inner,
  .ant-popover-inner,
  .ant-modal-body {
    font-family: "MuseoSansRounded", "Open Sans", Arial, sans-serif;
    font-weight: 300;
  }

  /* Ensure form labels and help text visible */
  label, .ant-form-item-label > label, .ant-form-item-extra {
    font-weight: 500;
  }

  /* Links inherit Museo and weight */
  a {
    font-family: "MuseoSansRounded", "Open Sans", Arial, sans-serif;
    font-weight: 300;
  }

  /* Accessibility / responsiveness */
  @media only screen and (max-width: ${screenSizes.small}px) {
    .page-header {
      top: auto;
      padding-right: 16px;
    }
    .page-header h2 {
      font-size: 16px;
      padding-left: 15px;
      padding-right: 15px;
      max-width: 100%;
    }

    /* reduce nested padding/margins on small screens to avoid cramped layout */
    .sidebar-scroll .ant-menu-submenu .ant-menu,
    .sidebar-scroll .ant-menu-submenu-popup .ant-menu {
      padding: 4px 6px !important;
    }
    .sidebar-scroll .ant-menu-submenu .ant-menu-item,
    .sidebar-scroll .ant-menu-submenu-popup .ant-menu-item {
      margin: 4px 0 !important;
    }
    .sidebar-scroll .ant-menu-submenu .ant-menu-item.ant-menu-item-selected,
    .sidebar-scroll .ant-menu-submenu-popup .ant-menu-item.ant-menu-item-selected {
      border-radius: 20px !important;
      margin: 4px 4px !important;
      padding-top: 6px !important;
      padding-bottom: 6px !important;
    }
  }

    /* Ensure a single authoritative layout rule for page content. This is the place where the page content is defined.

     Mirrors the old theme.css .content-body but uses CSS variables and ties to DashboardLayout structure.
     This ensures every page inside DashboardLayout gets consistent padding/width behavior. */
  .ant-layout .dashboard-page-container .content-body,
  .ant-layout .content-body {
    display: block;
    position: relative;
    vertical-align: top;
    box-sizing: border-box;
    /* top padding inside the white content card above each page header */
    padding-top: 0px;
    padding-left: 24px;
    padding-right: 24px;
    width: 100%;
    /* no overflow-x here — .content-body must stay overflow:visible so it doesn't become
       its own scroll container and break position:sticky descendants (see note on body,
       which is where horizontal-scroll-prevention correctly belongs instead) */
  }

  /* small screens follow original theme.css mobile behavior */
  @media only screen and (max-width: 767px) {
    .ant-layout .dashboard-page-container .content-body,
    .ant-layout .content-body {
      padding-top: 0px;
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  /* Modernized panel variant for updated pages (keeps legacy .panel for others) */
  .panel-modern {
    margin-top: 16px;
  }

  .panel-modern .panel-heading {
    background: transparent;
    border-bottom: none;
    padding: 0 0 12px 0;
  }

  .panel-modern .panel-title {
    font-size: 1.1rem;
    font-weight: 700;
  }

  .panel-modern .ourpanel-body {
    background: transparent;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
  }

  /* Club summary block tweaks */
  .panel-club-summary {
    margin-top: 8px;
  }

  .panel-club-summary .ourpanel-body {
    background: transparent;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
  }

  /* Allow submenu title to grow in height and wrap nicely (AntD v4 inline mode) */
.sidebar-scroll .ant-menu-inline .ant-menu-submenu-title {
  height: auto !important;           /* remove fixed 40px */
  line-height: 1.2 !important;       /* comfortable multi-line */
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  align-items: center !important;     /* icon + text alignment */
  display: flex !important;           /* ensure consistent layout */
}

/* Make sure icons don't force clipping and stay centered */
.sidebar-scroll .ant-menu-inline .ant-menu-submenu-title .anticon {
  align-self: flex-start;             /* aligns better with multi-line text */
  margin-top: 2px;                    /* subtle nudge */
}

/* Keep the caret centered relative to the (now variable) title height */
.sidebar-scroll .ant-menu-inline .ant-menu-submenu-title .ant-menu-submenu-arrow {
  top: 50% !important;
  transform: translateY(-50%) !important;
}

/* Two-line clamp with ellipsis for the league name text */
.sidebar-scroll .submenu-title-text {
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 2 !important;   /* clamp to 2 lines */
  overflow: hidden !important;
  white-space: normal !important;      /* allow wrapping */
  word-break: break-word;              /* avoid overflow on long tokens */
  /* Optional: add a tiny right padding so text doesn't kiss the caret */
  padding-right: 8px;
}

/* Allow submenu titles to grow vertically (v4 default is a fixed row height) */
.sidebar-scroll .ant-menu-submenu-title {
  height: auto !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  align-items: center !important; /* keep icon/caret centered */
}

/* Two-line clamp for our injected title text spans */
.sidebar-scroll .submenu-title-text {
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  white-space: normal !important;      /* allow wrapping */
  line-height: 1.1 !important;
  max-height: calc(2 * 1.1em) !important; /* 2 lines */
  margin-right: 8px;                   /* same caret spacing as league */
  color: #ffffff !important;           /* keep white */
}

/* Keep caret/arrow vertically centered next to multi-line text */
.sidebar-scroll .ant-menu-submenu-title .ant-menu-submenu-arrow,
.sidebar-scroll .ant-menu-submenu-title .ant-menu-submenu-expand-icon {
  align-self: center !important;
}

:root {
  /* ...existing vars... */
  --sidebar-divider-opacity: 0.15; /* adjust here to change all sidebar divider opacity */
  cursor: default !important;
}

/* Sidebar menu / Divider styling */
.sidebar-scroll .ant-menu-item-divider,
.sidebar-scroll .ant-menu-item.ant-menu-item-divider {
  border-top: 1px solid rgba(255,255,255,var(--sidebar-divider-opacity)) !important;
  margin: 12px 0 !important;
  cursor: default !important;
}

/* also cover AntD Divider component used in the sidebar */
.sidebar-scroll .ant-divider,
.sidebar-scroll .ant-divider-horizontal {
  border-color: rgba(255,255,255,var(--sidebar-divider-opacity)) !important;
  opacity: 1 !important; /* keeps the color opacity controlled by the rgba above */
  cursor: default !important;
}
    
  /* Ensure sidebar sits below application overlays (modals/drawers). */
  .ant-layout-sider,
  .sidebar-top-header,
  .sidebar-scroll,
  aside,
  #sidebar {
    z-index: 80 !important; /* lower than AntD modal/drawer default */
  }

  /* Ensure AntD modals/drawers/overlays are above the sidebar */
  .ant-modal,
  .ant-modal-root,
  .ant-modal-wrap,
  .ant-modal-mask,
  .ant-drawer,
  .ant-drawer-mask,
  .ant-drawer-content-wrapper,
  .ant-popover,
  .ant-tooltip,
  .ant-popover-open {
    z-index: 2000 !important;
  }

  /* fix react-pdf canvas overflow / bottom-bar in modals in curriculum pdf viewer */
  .ant-modal .react-pdf__Page__canvas,
  .ant-modal .react-pdf_page_canvas {
    position: static !important;
    display: block !important;
    box-sizing: border-box !important;
    max-width: calc(100vw - 32px) !important; /* match modal padding */
    height: auto !important;
    margin: 0 auto !important;
  }

  .ant-modal .react-pdf__Page,
  .ant-modal .react-pdf_page {
    box-sizing: border-box !important;
    padding: 16px !important;
  }

  /* ensure modal body never allows horizontal overflow from canvas */
  .ant-modal .ant-modal-body {
    overflow-x: hidden !important;
  }

  /* Remove underlines on hover for sidebar submenu links (antd v5 behavior) and prevent odd hover text color */
  .sidebar-scroll .ant-menu a,
  .sidebar-scroll .ant-menu .ant-menu-submenu .ant-menu-item a,
  .sidebar-scroll .ant-menu .ant-menu-submenu-title a,
  .sidebar-scroll .ant-menu .ant-menu-submenu .ant-menu-title-content a {
    text-decoration: none !important;
    color: inherit;
  }

  .sidebar-scroll .ant-menu a:hover,
  .sidebar-scroll .ant-menu .ant-menu-submenu .ant-menu-item a:hover,
  .sidebar-scroll .ant-menu .ant-menu-submenu-title a:hover,
  .sidebar-scroll .ant-menu .ant-menu-submenu .ant-menu-title-content a:hover {
    text-decoration: none !important;
    color: #ffffff !important;
    background: transparent;
  }

  /* ensure picker dropdowns sit above modals if needed */
  .ant-picker-dropdown,
  .rc-picker-dropdown,
  .ant-picker-dropdown[style] {
    z-index: 3000 !important;
  }

  /* used when you explicitly want a picker over everything */
  .picker-on-top.ant-picker-dropdown {
    z-index: 5000 !important;
  }

  /* Ensure AntD floating layers render above modals and escape stacking contexts */
  .ant-picker-dropdown,
  .rc-picker-dropdown,
  .ant-select-dropdown,
  .ant-dropdown,
  .ant-popover,
  .ant-tooltip,
  .rc-trigger-popup,
  .ant-picker-dropdown[style] {
    position: fixed !important;
    z-index: 10000 !important;
    will-change: transform;
  }

  /* Keep Select dropdown text/background readable */
  .ant-select-dropdown,
  .ant-select-dropdown .ant-select-item,
  .ant-select-dropdown .ant-select-item-option {
    background: #ffffff !important;
    color: #000000 !important;
  }
  .ant-select-item-option-content {
    color: inherit !important;
  }

  /* Restore Ant Design-style hover/active highlight for Select options */
  .ant-select-dropdown .ant-select-item-option-active:not(.ant-select-item-option-disabled),
  .ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background-color: #e6f7ff !important; /* AntD default primary-light */
    color: rgba(0, 0, 0, 0.85) !important;
  }

  /* Optional: ensure picker popup internal panels keep proper positioning */
  .rc-picker-panel {
    z-index: inherit !important;
  }

  /* used when you have modals on top of modals for modal confirmations */
  .confirm-merge-modal .ant-modal-wrap { z-index: 12050 !important; }
  .confirm-merge-modal .ant-modal-mask { z-index: 12040 !important; }

  /* antd v5 Segmented size=small label text vertical centering fix */
  .relay-segmented .ant-segmented-item-label,
  .event-type-filter .ant-segmented-item-label {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  
`

export default GlobalStyles